import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAr: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAr"><Path d="M1.5 5.5H22.5V19.5H16.1L12 15.825L7.9 19.5H1.5V5.5Z" stroke="currentColor"/><Path d="M9.5 11.5C9.5 12.6046 8.60457 13.5 7.5 13.5C6.39543 13.5 5.5 12.6046 5.5 11.5C5.5 10.3954 6.39543 9.5 7.5 9.5C8.60457 9.5 9.5 10.3954 9.5 11.5Z" stroke="currentColor"/><Path d="M18.75 11.75C18.75 12.8546 17.8546 13.75 16.75 13.75C15.6454 13.75 14.75 12.8546 14.75 11.75C14.75 10.6454 15.6454 9.75 16.75 9.75C17.8546 9.75 18.75 10.6454 18.75 11.75Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconAr;
